import React from 'react';
import QuestionLabel from './QuestionLabel';
import { parse, format } from 'date-fns';
import { dateStringToDateTime, formatInternalDate } from '~/lib/DateTime';

const TextQuestion = ({ label, value, setValue, settings }) => {
    const formatStr = 'LLLL d, yyyy';
    const inputValue = value
        ? formatInternalDate(parse(value, formatStr, new Date()))
        : '';

    function onChange(newInputValue) {
        if (newInputValue) {
            const newValue = format(dateStringToDateTime(newInputValue), formatStr);
            setValue(newValue);
        } else {
            setValue('');
        }

    }

    return (
        <label>
            <QuestionLabel label={label} settings={settings} />
            <div>
                <input
                    type="date"
                    value={inputValue}
                    onChange={e => onChange(e.target.value)}
                />
            </div>
        </label>
    );
};

export default TextQuestion;
